import(/* webpackMode: "eager" */ "/vercel/path0/app/base64-encoder/page.tsx");
